import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },
  {
    path: "/meals",
    name: "Meals",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "meals" */ "../views/Meals.vue")
  },
  {
    path: "/meal-planner",
    name: "MealPlanner",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "meal-planner" */ "../views/MealPlanner.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // const app = Store.getters.app;
  // document.title = `${to.name} - ${app.name}`;
  // const loggedIn = Store.getters.isLoggedIn || false;
  // if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
  //   next({ name: "login" });
  // }
  next();
});

export default router;
